import React from 'react';
import { RotateCcwIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
export function Footer() {
  const {
    openDialog
  } = useDemo();
  return <footer className="border-t border-line bg-paper" data-id="element-436" data-mp="2kbtryytje5xp">
      <div className="mx-auto flex max-w-6xl flex-col gap-3 px-4 py-5 text-sm sm:flex-row sm:items-center sm:justify-between sm:px-6" data-id="element-437" data-mp="2kail2q4soi2d">
        <div data-id="element-438" data-mp="2faw88hsvp3u3">
          <p className="font-bold text-forest" data-id="element-439" data-mp="2addzosirwqmm">Educational demo. Not therapy or emergency support.</p>
          <p className="text-ink/80" data-id="element-440" data-mp="25esvki0ehmsw">Your choices stay in this page only. Refreshing may reset the demo.</p>
        </div>
        <button type="button" onClick={() => openDialog('restart')} className="inline-flex min-h-[44px] items-center gap-2 self-start rounded-full px-3 text-forest underline-offset-4 transition-colors duration-150 hover:bg-sand hover:underline sm:self-auto" data-id="element-441" data-mp="21c63qh3qc1vp">
          <RotateCcwIcon size={16} aria-hidden="true" data-id="element-442" data-mp="3qrma5oq9r9hw" />
          Restart demo
        </button>
      </div>
    </footer>;
}